import axios from 'axios';
import SessionService from './SessionService';
import { config } from '../config';

const API_URL = config?.API_BASE_URL || process.env.REACT_APP_API_URL || 'https://server.mends.pro/api';

export const translateText = async (
    sectorId: number,
    text: string,
    targetLanguage: string = 'pt-BR'
): Promise<string> => {
    const token = SessionService.getToken();
    if (!token) throw new Error('Authentication token not found');

    const res = await axios.post(
        `${API_URL}/Translation/translate`,
        { sectorId, text, targetLanguage },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }
    );

    const translated = res.data?.data?.translatedText;
    if (typeof translated !== 'string') {
        throw new Error(res.data?.message || 'Translation failed');
    }
    return translated;
};
